



















import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public modal = false;
  public val = "";
  public submit() {
    this.$fn.cookies.removeToken();
    window.App.$store.dispatch("user/authInfo", "");
    window.location.reload();
  }
  /* public active() {
      this.$Modal.error({
      title: "该账号已在其他地方登录",
      content: "obj.msg",
      onOk: () => {
        this.$fn.cookies.removeToken();
        window.App.$store.dispatch("user/authInfo", "");
        window.location.reload();
      },
    });
  } */
}
